import { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import { HiOutlineDocumentText } from "react-icons/hi2";

import classes from "./LegalPage.module.css";
import { bankName, email } from "../../util/config";

const TermsAndConditions = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Terms &amp; Conditions — {bankName}</title>
        <meta
          name="description"
          content={`Website and service terms for ${bankName} customers and visitors.`}
        />
        <link rel="canonical" href="/terms" />
      </Helmet>
      <div className={classes.legal}>
        <header className={classes.legalHeader}>
          <h1 className={classes.legalTitle}>
            <HiOutlineDocumentText className={classes.legalTitleIcon} aria-hidden />
            Terms &amp; Conditions
          </h1>
          <p className={classes.lastUpdated}>Last updated: 12 April 2026</p>
        </header>
        <article className={classes.article}>
          <h2>Agreement</h2>
          <p>
            By accessing this website or using {bankName} digital services, you
            agree to these terms together with any product-specific terms,
            schedules, and disclosures provided when you open or use an account,
            loan, or insurance policy.
          </p>

          <h2>Services</h2>
          <p>
            Online and mobile banking are provided subject to security
            procedures, eligibility, and our acceptance of your application.
            Features may vary by customer segment and jurisdiction. We may
            change or suspend services where required by law or for operational
            reasons, giving notice where we are required to do so.
          </p>

          <h2>Your responsibilities</h2>
          <ul>
            <li>
              Keep credentials confidential and notify us promptly if you
              suspect unauthorised access.
            </li>
            <li>
              Provide accurate information and update us when your circumstances
              change in ways that affect our services.
            </li>
            <li>
              Use our systems only for lawful purposes and in line with
              acceptable use policies we publish from time to time.
            </li>
          </ul>

          <h2>Intellectual property</h2>
          <p>
            Content on this site (including logos, text, and design) is owned
            by {bankName} or its licensors. You may not copy, modify, or distribute
            it without our prior written consent except as allowed by applicable
            law.
          </p>

          <h2>Limitation of liability</h2>
          <p>
            To the fullest extent permitted by law, we exclude liability for
            indirect or consequential loss arising from use of this site,
            except where such exclusion is not permitted (for example, death or
            personal injury caused by negligence, or fraud). Nothing in these
            terms limits your statutory rights as a consumer where applicable.
          </p>

          <h2>Third-party links</h2>
          <p>
            Links to third-party sites are provided for convenience. We do not
            control their content or privacy practices and are not responsible
            for them.
          </p>

          <h2>Governing law</h2>
          <p>
            These terms are governed by the laws of England and Wales, unless
            mandatory consumer protections in your country of residence require
            otherwise. Courts in England and Wales have non-exclusive
            jurisdiction, without prejudice to rights you may have to bring
            proceedings in your home courts where the law allows.
          </p>

          <h2>Changes</h2>
          <p>
            We may update these terms periodically. The “Last updated” date at
            the top will change when we do. Continued use after changes
            constitutes acceptance where the law permits; for material changes
            to regulated products, we will follow the notice requirements that
            apply to you.
          </p>

          <div className={classes.contactBox}>
            <p>
              <strong>Questions:</strong>{" "}
              <a href={`mailto:${email}`}>{email}</a>
            </p>
          </div>
        </article>
      </div>
    </Fragment>
  );
};

export default TermsAndConditions;
